import InlineEditors from '../../../controllers/inlineEditors';
import getDefaultCell from './getDefaultCell';
import { getBaselineTemplate, getDefaultTemplateWithTooltip } from '../helpers';
import rights from '../../../../../components/rights';

export default function (data) {
  const { task, instance } = data;
  const isEditDisable = InlineEditors.checkByLinkDependency(data.task, data.column.name);
  const isProject = task.type === instance.config.types.project;
  let tooltipKey = '';

  if (isProject && rights.project.hasRight(task.gantt_id, 'static_fields')) {
    tooltipKey = 'why_can_not_set_it_case1';
  }

  if (isEditDisable && task.type === instance.config.types.task) {
    tooltipKey = 'why_can_not_set_it_case5';
  }

  if (tooltipKey) {
    const baselineTemplate = data.isBaseline ? getBaselineTemplate(data.baselineValue) : '';

    return `${getDefaultTemplateWithTooltip(data.cellValue, tooltipKey)}${baselineTemplate}`;
  }

  return getDefaultCell(data);
}
